import { useCallback } from 'react'
import Toggle from 'react-toggle'
import { useSelector, useDispatch } from 'react-redux'
import { map, find, filter, sortBy, isEmpty } from 'lodash'
import { useHistory, useLocation } from 'react-router-dom'

import Loader from 'components/Loader'
import Section from 'components/Section'
import PriceLevelsForm from 'components/PriceLevels/Form'

import {
  getSalesEventTypes,
  getIsSalesEventTypeLoading,
} from 'store/SalesEventTypes/selectors'
import { updateSalesEventType } from 'store/SalesEventTypes/actions'

const PriceLevelsList = () => {
  const history = useHistory()
  const { state: urlQueryParamsState } = useLocation()

  const dispatch = useDispatch()

  const salesEventTypes = useSelector((state) =>
    getSalesEventTypes(state)
  )
  const isLoading = useSelector((state) =>
    getIsSalesEventTypeLoading(state)
  )

  const isModal = !isEmpty(urlQueryParamsState?.salesEventUuid)

  // we won't show loader on the list when modal is open
  const isLoadingPriceLevels = isLoading && !isModal

  const sortedSalesEventTypes = sortBy(salesEventTypes, 'name')

  const onSalesEventTypeActiveChange = useCallback(
    (event) => {
      const salesEventTypeToChangeActive = find(
        salesEventTypes,
        (salesEventTypes) => salesEventTypes.uuid === event.target.id
      )

      const restSalesEventTypeToUpdate = filter(
        salesEventTypes,
        (salesEventType) => salesEventType.uuid !== event.target.id
      ).map((salesEventType) => ({
        ...salesEventType,
        active: false,
      }))

      const salesEventTypeActiveStatesToUpdate = {
        sales_event_types: [
          ...restSalesEventTypeToUpdate,
          {
            ...salesEventTypeToChangeActive,
            active: !salesEventTypeToChangeActive.active,
          },
        ],
      }

      dispatch(
        updateSalesEventType(salesEventTypeActiveStatesToUpdate)
      )
    },
    [salesEventTypes]
  )

  return isLoadingPriceLevels ? (
    <Loader />
  ) : (
    <>
      <Section className="item-list">
        {map(sortedSalesEventTypes, (salesEvents) => (
          <div className="item" key={salesEvents.uuid}>
            <div className="row">
              <div
                className="item-info-wrapper"
                onClick={() =>
                  history.push({
                    state: { salesEventUuid: salesEvents.uuid },
                  })
                }
              >
                {salesEvents.name}
              </div>
              <div className="item-info-wrapper">
                <Toggle
                  id={salesEvents.uuid}
                  name={salesEvents.name}
                  checked={salesEvents.active}
                  onChange={onSalesEventTypeActiveChange}
                />
              </div>
            </div>
          </div>
        ))}
      </Section>
      {isModal && <PriceLevelsForm />}
    </>
  )
}

PriceLevelsList.propTypes = {}

export default PriceLevelsList
